module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "imgcenter"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "id": "img10_1",
      "src": "images/img10_1.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("Major General Wood addressing trainee officers at Fort McPherson, First Officers’Training Camp, Plattsburg.")]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("6US")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-06979280","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/01i_AMERICAN_EXPEDITIONARY_FORCE.vue
// module id = 96
// module chunks = 0